/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

export const toastsSelector = createSelector(
	(state) => state.toasts,
	(toasts) => toasts,
);
